import React from 'react';

import { Breadcrumb as AntDBreadcrumb } from 'antd';
import { BreadcrumbProps } from 'antd/lib/breadcrumb';
import { Route } from 'antd/lib/breadcrumb/Breadcrumb';
import { Link } from 'react-router-dom';

import { ReactComponent as ChevronRightSVG } from '../../../assets/sightx-icons/svg/icon-chevron-right.svg';

import styles from './index.module.scss';
import Icon from '@ant-design/icons';

interface BreadcrumbRoute extends Route {
  key: string;
  absolutePath?: string;
}

interface IBreadcrumbProps extends BreadcrumbProps {
  routes: BreadcrumbRoute[];
}

export class Breadcrumb extends React.Component<IBreadcrumbProps> {
  render(): React.ReactNode {
    const { separator, ...remainingProps } = this.props;
    // The BreadcrumbProps interface has the function defined with 4 parameters
    // we can't change the implementation of that to remove the next line
    // eslint-disable-next-line max-params
    const itemRender = (route: Route, _params: unknown, routes: Array<Route>, paths: Array<string>) => {
      if (!routes.length) {
        return null;
      }
      const currentRoute = this.props.routes.find(currRoute => currRoute.breadcrumbName === route.breadcrumbName);
      const last = routes.indexOf(route) === routes.length - 1;
      const key = this.props.routes.find((item) => item.breadcrumbName === route.breadcrumbName && item.path === route.path)?.key ?? '';
      const routeName = route?.breadcrumbName || '';
      return last ? (
        <span key={key} className={styles.content}>{routeName}</span>
      ) : (
        <Link key={key} to={currentRoute?.absolutePath || paths.join('/')} className={styles.link}>{routeName}</Link>
      );
    };

    return (
      <AntDBreadcrumb
        className={styles.breadcrumb}
        itemRender={itemRender}
        separator={separator || <Icon component={ChevronRightSVG} className={styles.separator} />}
        {...remainingProps}
      />
    );
  }
}